import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Mic, CheckCircle2, XCircle } from 'lucide-react';

// Публичная страница: сюда ведёт ссылка из письма. Аккаунт к этому моменту может быть
// уже заблокирован за просрочку, поэтому Bearer-токена здесь может и не быть.
export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { user, verifyEmail, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState(token ? 'verifying' : 'error');
  const [message, setMessage] = useState(token ? '' : 'This link is missing its confirmation token.');
  // StrictMode в dev монтирует компонент дважды — без этого флага второй вызов уходил
  // бы с уже погашенным токеном и рисовал ошибку поверх успеха.
  const started = useRef(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    verifyEmail(token)
      .then(async () => {
        setState('success');
        if (user) {
          // Профиль в контексте ещё считает email неподтверждённым — иначе баннер
          // остался бы висеть до перезагрузки страницы.
          await refreshUser().catch(() => {});
        }
      })
      .catch(err => {
        setState('error');
        setMessage(err.response?.data?.error || 'Could not confirm this email address.');
      });
  }, [token, user, verifyEmail, refreshUser]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Mic size={32} />
          <h1>Voice AI Portal</h1>
        </div>

        {state === 'verifying' && (
          <div style={{ textAlign: 'center' }}>
            <div className="spinner" />
            <p className="helper-text" style={{ marginTop: 16 }}>Confirming your email address...</p>
          </div>
        )}

        {state === 'success' && (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle2 size={40} color="#22c55e" />
            <h2 style={{ margin: '12px 0 8px' }}>Email confirmed</h2>
            <p className="helper-text">Your account stays active. Thanks!</p>
            <button
              className="btn btn-primary btn-full"
              onClick={() => navigate(user ? '/dashboard' : '/login')}
            >
              {user ? 'Go to dashboard' : 'Sign in'}
            </button>
          </div>
        )}

        {state === 'error' && (
          <div style={{ textAlign: 'center' }}>
            <XCircle size={40} color="#ef4444" />
            <h2 style={{ margin: '12px 0 8px' }}>Confirmation failed</h2>
            <p className="helper-text">{message}</p>
            <p className="auth-footer">
              Already confirmed? <Link to="/login">Sign in</Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
